import { render, staticRenderFns } from "./PageNoAccess.vue?vue&type=template&id=ae7e5b86"
import script from "./PageNoAccess.vue?vue&type=script&lang=js"
export * from "./PageNoAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7e5b86')) {
      api.createRecord('ae7e5b86', component.options)
    } else {
      api.reload('ae7e5b86', component.options)
    }
    module.hot.accept("./PageNoAccess.vue?vue&type=template&id=ae7e5b86", function () {
      api.rerender('ae7e5b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/PageNoAccess.vue"
export default component.exports